export default "__VITE_ASSET__o3Y2i7ze__"